<script>
import Base from "@/components/RequestDetails/PrePayment.vue";

export default {
  name: "CustomerServicePrePayment",
  extends: Base,
};
</script>

